import { render, staticRenderFns } from "./SBTextareaWrapper.vue?vue&type=template&id=2514e023&scoped=true&"
import script from "./SBTextareaWrapper.vue?vue&type=script&lang=js&"
export * from "./SBTextareaWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SBTextareaWrapper.vue?vue&type=style&index=0&id=2514e023&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514e023",
  null
  
)

export default component.exports